import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import {
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
  PanelContentContainer,
  NameFormContainer,
} from "~/OnboardingApp/components";
import { InputSection } from "./InputSection";

export const RightSection: FC = () => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" px="1rem" w="full">
      <QuestionPageContainer maxW="22.375rem" pt={0} px={0}>
        <PanelContentContainer>
          <NameFormContainer>
            <QuestionContainer>
              <Prompt question={t("onboarding.welcomeNamePage.question")} />

              <InputSection />
            </QuestionContainer>

            <NextButton />
          </NameFormContainer>
        </PanelContentContainer>
      </QuestionPageContainer>
    </Flex>
  );
};
